import InsightsNewsSearch from './InsightsNewsSearch';

export { type InsightsNewsSearchProps } from './InsightsNewsSearch';
export default InsightsNewsSearch;
